<script lang="ts">
  import Caret from "~icons/ph/caret-down";
</script>

<details>
  <summary>How was the gross amount determined?<Caret /></summary>
  <p>
    The gross amount is an offer from the finance company. This offer takes into account the commission paid, the
    structure of the commission, and other factors outlined by the FCA and courts.
  </p>
</details>
